var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('confirm',{attrs:{"title":"仮登録完了","description":"ご登録のメールアドレスにユーザ登録のご案内をお送り致しました。お手数ですがメールの内容に沿って本登録にお進み下さい。","to":"login"}})}
var staticRenderFns = []

export { render, staticRenderFns }